import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setResizingActive, setRightPaneWidth } from "../../slices/rootSlice";
import { useRootSelector } from "../../../hooks/useAppSelector";
import Api from "../../../api";
export const useResizeHandler = () => {
    const dispatch = useDispatch();
    const { isResizingActive, activeDockedTabKey, tabs, appSettings } = useRootSelector();
    const mouseUp = (event) => {
        if (isResizingActive && activeDockedTabKey) {
            const activeDockedTab = tabs[activeDockedTabKey];
            if (activeDockedTab.menuId) {
                const width = ((window.innerWidth - event.clientX) / window.innerWidth) * 100;
                const tabConfig = appSettings.StaticData.MenuItems[activeDockedTab.menuId];
                const widthClamp = Math.min(Math.max(width, tabConfig.MinimumDockedSize), tabConfig.MaximumDockedSize);
                dispatch(setRightPaneWidth(widthClamp));
                Api.setDockedTabWidth(activeDockedTab.menuId, widthClamp);
            }
        }
        if (isResizingActive)
            dispatch(setResizingActive(false));
    };
    const mouseMove = (event) => {
        if (isResizingActive && activeDockedTabKey) {
            const activeDockedTab = tabs[activeDockedTabKey];
            if (activeDockedTab.menuId) {
                const width = ((window.innerWidth - event.clientX) / window.innerWidth) * 100;
                const tabConfig = appSettings.StaticData.MenuItems[activeDockedTab.menuId];
                const widthClamp = Math.min(Math.max(width, tabConfig.MinimumDockedSize), tabConfig.MaximumDockedSize);
                dispatch(setRightPaneWidth(widthClamp));
            }
        }
    };
    useEffect(() => {
        window.addEventListener("mouseup", mouseUp);
        window.addEventListener("mousemove", mouseMove);
        return () => {
            window.removeEventListener("mouseup", mouseUp);
            window.removeEventListener("mousemove", mouseMove);
        };
    }, [, isResizingActive]);
};
